import request from './request.service';
import { api } from '../config';

export const getCountries = async () => {
  const response = await request(api.getCountries, {
    method: 'GET',
  });
  return response.body;
};

export const createConfiguration = async body => {
  const response = await request(api.createConfiguration, {
    method: 'POST',
    body,
  });
  return response.body;
};
